(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kb-commerce-support"] && !Shopify.designMode) return;
  try {
    window.DetailsDisclosure = class extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle?.querySelector('summary')?.nextElementSibling;
    this.mainDetailsToggle?.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle?.addEventListener('toggle', this.onToggle.bind(this));
  }
  onFocusOut() {
    setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); });
  }
  onToggle() {
    this.animations ||= this.content?.getAnimations() || [];
    this.animations.forEach(animation => this.mainDetailsToggle.open ? animation.play() : animation.cancel());
  }
  close() {
    this.mainDetailsToggle?.removeAttribute('open');
    this.mainDetailsToggle?.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  }
};
if (!customElements.get('details-disclosure')) customElements.define('details-disclosure', window.DetailsDisclosure);
window.SearchForm = class extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    if (this.input) {
      this.input.form?.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener('input', event => {
        clearTimeout(this.inputTimer);
        this.inputTimer = setTimeout(() => this.onChange(event), 300);
      });
    }
  }
  toggleResetButton() {
    this.resetButton?.classList.toggle('hidden', !this.input?.value.length);
  }
  onChange() { this.toggleResetButton(); }
  shouldResetForm() { return !document.querySelector('[aria-selected="true"] a'); }
  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
};
if (!customElements.get('search-form')) customElements.define('search-form', window.SearchForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kb-gallery"] && !Shopify.designMode) return;
  try {
    function kbInitializeGallery(root = document) {
  const galleries = root.querySelectorAll('[data-kb-gallery]');
  galleries.forEach(gallery => {
    if (gallery.dataset.ready) return;
    const dialog = gallery.querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    gallery.dataset.ready = 'true';
    const links = Array.from(gallery.querySelectorAll('.kb-photo-link'));
    const image = dialog.querySelector('.kb-lightbox-image');
    const caption = dialog.querySelector('.kb-lightbox-caption');
    const counter = dialog.querySelector('.kb-lightbox-counter');
    const loading = dialog.querySelector('.kb-lightbox-loading');
    let active = 0, returnFocus, previousOverflow;
    function show(index) {
      active = (index + links.length) % links.length;
      const link = links[active];
      const thumbnail = link.querySelector('img');
      image.src = thumbnail.currentSrc || thumbnail.src;
      image.alt = thumbnail.alt;
      loading.hidden = false;
      const fullImage = new Image();
      const selectedLink = link;
      fullImage.onload = () => {
        if (links[active] !== selectedLink) return;
        image.src = fullImage.src;
        loading.hidden = true;
      };
      fullImage.onerror = () => { if (links[active] === selectedLink) loading.hidden = true; };
      fullImage.src = link.href;
      caption.textContent = link.dataset.caption;
      counter.textContent = (active + 1) + ' / ' + links.length;
    }
    links.forEach((link, index) => link.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault(); returnFocus = link; show(index);
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
    }));
    dialog.querySelector('.kb-lightbox-close').addEventListener('click', () => dialog.close());
    dialog.querySelector('.kb-lightbox-prev').addEventListener('click', () => show(active - 1));
    dialog.querySelector('.kb-lightbox-next').addEventListener('click', () => show(active + 1));
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(active - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(active + 1); }
    });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow || '';
      if (returnFocus) returnFocus.focus({ preventScroll: true });
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => kbInitializeGallery());
else kbInitializeGallery();
document.addEventListener('shopify:section:load', event => kbInitializeGallery(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kb-partnerships"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    const select = document.getElementById('kb-inquiry-topic');
    const topic = new URLSearchParams(location.search).get('inquiry');
    if (select && topic && Array.from(select.options).some((option) => option.value === topic)) select.value = topic;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
